import React from 'react'
import type { TaskInlineInputProps } from './TaskInlineInput'
import { TaskInlineInput } from './TaskInlineInput'
import { TagsInlineInput } from '@ztechapps/webui.input'

export const TaskTagsInlineInput = ({
  help = 'Add tags for this task',
  name = 'tags',
  label = 'Tags',
  parentInputComponent,
  ...props
}: TaskInlineInputProps) => {
  const ParentInput = parentInputComponent || TaskInlineInput

  return (
    <ParentInput
      help={help}
      label={label}
      name={name}
      parentInputComponent={TagsInlineInput}
      inputProps={{ className: 'justify-content-end' }}
      {...props}
    />
  )
}
